<!-- Header -->
<div mat-dialog-title class="flex justify-between items-center">
  <div class="w-full flex justify-between items-center">
    <span class="text-lg font-medium">Mise à jour du statut</span>
  </div>
</div>

<!-- Dialog Content -->
<mat-dialog-content class="flex flex-col text-center py-6">
  <div class="flex flex-col space-y-4">
    <!-- Extracting State -->
    <ng-container *ngIf="!isExtracted">
      <app-creation-analysis-progress
        class="w-full"
        [progressPercent]="draftProgressPercent"
        [statusMessage]="draftProgressMessage">
      </app-creation-analysis-progress>

      <!-- Text aligned left -->
      <div class="text-left space-y-2">
        <p>Extraction en cours. Cela peut prendre quelques minutes.</p>

        <p class="font-semibold">Options :</p>
        <ul class="list-disc pl-5 space-y-1">
          <li>
            <span class="font-semibold">Continuer sans attendre :</span>
            ce bouton vous permet de quitter cette page et de revenir plus tard
            pour voir les résultats du traitement.
          </li>
          <li>
            <span class="font-semibold">Attendre :</span>
            si vous attendez, vous serez automatiquement redirigé vers la
            fiche détail du projet.
          </li>
        </ul>
      </div>

    </ng-container>

    <!-- Done State -->
    <ng-container *ngIf="isExtracted">
      <div class="flex flex-col items-center justify-center space-y-4">
        <mat-icon color="accent" style="font-size: 40px;">assignment_turned_in</mat-icon>
        <p>Extraction terminée!</p>
      </div>
    </ng-container>
  </div>
</mat-dialog-content>

<!-- Dialog Actions -->
<mat-dialog-actions class="flex justify-end mt-4 space-x-2">
  <button mat-stroked-button color="warn" *ngIf="!isExtracted" (click)="redirectWithoutWaiting()">
    Continuer sans attendre
  </button>
</mat-dialog-actions>
